module.exports = __webpack_public_path__ + "img/search-filter.e9d0d47d.png";